import { Component, OnDestroy, OnInit } from '@angular/core';
import { SolScriptsLoaderService } from 'src/app/services/sol-scripts-loader.service';
import {
  trigger,
  transition,
  style,
  animate,
  state
} from '@angular/animations';
import { SolApiService } from 'src/app/services/sol-api.service';
import { SolUrls } from 'src/app/services/sol-urls';
import { State } from 'src/app/utilities/state';
import { I18nService } from 'src/app/services/i18n.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NguCarouselConfig } from '@ngu/carousel';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-main-index',
  templateUrl: './main-index.component.html',
  styleUrls: ['./main-index.component.scss'],
  animations: [
    trigger('enterAnimation', [
      state(
        'animate',
        style({
          transform: 'translateX(0)'
        })
      ),
      state(
        'unAnimate',
        style({
          transform: 'translateX(0)'
        })
      ),
      transition('unAnimate => animate', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition('animate => unAnimate', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ])
    ]),
    trigger('fraudItemImageState', [
      state(
        'animate',
        style({
          transform: 'translateX(0)'
        })
      ),
      state(
        'unAnimate',
        style({
          transform: 'translateX(0)'
        })
      ),
      transition('unAnimate => animate', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition('animate => unAnimate', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ])
    ]),
    trigger('fraudItemTitleState', [
      state(
        'animate',
        style({
          transform: 'translateX(0)'
        })
      ),
      state(
        'unAnimate',
        style({
          transform: 'translateX(0)'
        })
      ),
      transition('unAnimate => animate', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition('animate => unAnimate', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('500ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ])
    ]),
    trigger('fraudItemDescriptionState', [
      state(
        'animate',
        style({
          transform: 'translateX(0)'
        })
      ),
      state(
        'unAnimate',
        style({
          transform: 'translateX(0)'
        })
      ),
      transition('unAnimate => animate', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('900ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition('animate => unAnimate', [
        style({ transform: 'translateX(-100%)', opacity: 0 }),
        animate('900ms', style({ transform: 'translateX(0)', opacity: 1 }))
      ])
    ])
  ]
})
export class MainIndexComponent implements OnInit, OnDestroy {
  animateState = 'unAnimate';
  sliderState = 'unAnimate';
  fraudItemImageState = 'unAnimate';
  fraudItemTitleState = 'unAnimate';
  fraudItemDescriptionState = 'unAnimate';
  currentSlider = 'slider0';
  currentSliderIndex = 0;
  search = false;
  voteAnswer;
  images = [
    '../../../assets/img/bac1.jpg',
    '../../../assets/img/02.jpg',
    '../../../assets/img/03.jpg'
  ];

  currentLang: String;

  state: State = new State();
  urls: SolUrls = new SolUrls();
  urlSafe: SafeResourceUrl;
  // sliderData = [];
  subFraudCategory = [];
  newSubFraudCategory = [];
  fraudMenuItems = [];
  fraudTypes: { title: string; description: string; image: string }[] = [];
  fraudTypesIcons: string[] = [];
  videoSection: {
    title_video: string;
    title_video_en: string;
    description_video: string;
    description_video_en: string;
    youtube: string;
    uploaded_video: string;
  }[] = [];
  currentFraudIndex = -1;
  currentFraudType: any = { title: "", title_en: "", description: "", description_en: "", image: "" };
  disclamer = {
    text: "",
    text_en: ""
  }
  imageHead = document.getElementById('index-back');
  importantLinks: [];
  innerWidth;
  experiments = [];
  newExperiments = [];
  safeSrc: SafeResourceUrl;
  carouselOne: NguCarouselConfig;
  showDisclamerFlag = "true";
  timer: any;
  constructor(
    private scriptLoader: SolScriptsLoaderService,
    private apiService: SolApiService,
    private i18nService: I18nService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {
    if (localStorage.getItem("voted")) {
      this.votedFlag = true;
    }
    this.getVoteResult();
    this.i18nService.getLang().subscribe((lng) => {
      if (lng == null) {
        lng = 'ar';
      }
      this.currentLang = lng;

    })


    this.showDisclamerFlag = localStorage.getItem("agree");
    if (this.showDisclamerFlag == null) {
      this.showDisclamerFlag = "false";
    }

  }
  ngOnDestroy(): void {
    clearInterval(this.timer);
  }
  votedFlag = false;
  voteResult = {
    yes: 0,
    yes_persent: 0,
    no: 0,
    no_persent: 0
  }
  tempResultShow = false;



  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.scriptLoader.lazyLoadQuill();
    document.getElementById('index-back').style.backgroundImage =
      'url(' + this.images[0] + ')';
    this.getDisclamerText();
    this.getHome();
    this.getImportantLinks();
    this.getExperiments();
    this.getLatestFraudSub();

    this.changeBackground();
    this.carouselOne = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      slide: 1,
      speed: 400,
      interval: {
        timing: 6000,
        initialDelay: 1000
      },
      point: {
        visible: true
      },
      load: 3,
      loop: true,
      touch: true,
      RTL: true
    }

  }

  getDisclamerText() {
    this.apiService
      .get(false, 'getParagraphPages', 'name=تنبيه الصفحة الرئيسية')
      .subscribe((response: any) => {
        this.disclamer = {
          text: response.data.paragraphPage.text,
          text_en: response.data.paragraphPage.text_en
        }

        // document.getElementById("text").innerHTML =  this.currentLang == 'ar' ? this.disclamer.text : this.disclamer.text_en;
      })
  }
  getLatestFraudSub() {
    this.apiService
      .get(false, 'latestFraudSubCategory', 'paragraphPageName=أهم حالات النصب والاحتيال')
      .subscribe((response: any) => {
        this.subFraudCategory = Object.values(response.data.fraudTypes);
        this.addMoreToSubFraud(this.subFraudCategory)
      })
  }

  changeBackground() {
    let i = 0;
    const This = this;
    this.timer = setInterval(() => {
      i = i + 1;
      if (i === This.images.length) {
        i = 0;
      }
      document.getElementById('index-back').style.backgroundImage =
        'url(' + This.images[i] + ')';
      this.animateState =
        this.animateState === 'animate' ? 'unAnimate' : 'animate';
    }, 8000);
  }

  getHome() {
    this.state.operating = true;
    this.apiService
      .get(false, 'homePage', 'paragraphPageName=أهم حالات النصب والاحتيال')
      .subscribe(response => {
        this.moreAndLess();
        this.fraudTypes = response.data.fraudTypes;
        this.videoSection = response.data.homePage;

        this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoSection[0].youtube);
        this.changeFraudTypes();
        this.assignIcons();
        this.currentFraudIndex++;
        this.currentFraudType = this.fraudTypes[this.currentFraudIndex];
        this.moreAndLess();
        this.state.operating = false;
        this.state.loaded = true;
      });
  }

  assignIcons() {
    this.fraudTypes.forEach(item => {
      this.fraudTypesIcons.push(this.getFarudTypesImage(item.image));
    });
  }

  getFarudTypesImage(image: string) {
    // this if conditions solved jason parse Error of empty array
    if (image.length > 0) {
      return JSON.parse(image)[0].download_link;
    }
  }

  getVideoLink() {
    
    return this.sanitizer.bypassSecurityTrustResourceUrl('http://'+environment.url +'/storage/'+ JSON.parse(this.videoSection[0].uploaded_video)[0].download_link);
  }

  changeSlider(to: string) {
    if (to === 'next') {
      this.currentSliderIndex++;
      if (this.currentSliderIndex >= this.subFraudCategory.length) {
        this.currentSliderIndex = 0;
      }
      this.currentSlider = 'slider' + this.currentSliderIndex;
      this.sliderState =
        this.sliderState === 'animate' ? 'unAnimate' : 'animate';
    } else {
      this.currentSliderIndex--;
      if (this.currentSliderIndex < 0) {
        this.currentSliderIndex = this.subFraudCategory.length - 1;
      }
      this.currentSlider = 'slider' + this.currentSliderIndex;
      this.sliderState =
        this.sliderState === 'animate' ? 'unAnimate' : 'animate';
    }
    this.addMoreToSubFraud(this.subFraudCategory)
  }

  changeFraudTypes() {
    setInterval(() => {
      if (this.fraudTypes.length - 1 === this.currentFraudIndex) {
        this.currentFraudIndex = -1;
      }
      this.currentFraudIndex++;
      this.currentFraudType = this.fraudTypes[this.currentFraudIndex];
      this.moreAndLess();
      this.animateFraudTypes();

    }, 5000);
  }

  animateFraudTypes() {
    this.fraudItemImageState =
      this.fraudItemImageState === 'animate' ? 'unAnimate' : 'animate';
    this.fraudItemTitleState =
      this.fraudItemTitleState === 'animate' ? 'unAnimate' : 'animate';
    this.fraudItemDescriptionState =
      this.fraudItemDescriptionState === 'animate' ? 'unAnimate' : 'animate';
  }

  fraudTypesClick(index: number) {
    this.currentFraudIndex = index;
    this.currentFraudType = this.fraudTypes[this.currentFraudIndex];
    this.moreAndLess();
    this.animateFraudTypes();
  }

  getImportantLinks() {
    this.apiService.get(false, 'getImportantLinks', {}).subscribe((links) => {
      this.importantLinks = links.data.importantLinks;
    })
  }
  vote() {
    if (this.voteAnswer) {
      this.state.operating = true;
      this.state.state = '';
      this.state.message = '';

      this.apiService
        .post(false, "addVote", { vote: this.voteAnswer })
        .subscribe(response => {
          this.state.operating = false;

          if (response.code == 200 && response.msg === 'SUCCESS') {
            localStorage.setItem("voted", "true");
            this.votedFlag = true;
          }
        });

    }
  }
  getVoteResult() {
    this.state.operating = true;
    this.state.state = '';
    this.state.message = '';

    this.apiService
      .get(false, "getVotes", {})
      .subscribe(response => {
        this.state.operating = false;

        if (response.code == 200 && response.msg === 'SUCCESS') {
          this.voteResult.yes = response.data.voteFraud.yes_vote;
          this.voteResult.no = response.data.voteFraud.no_vote;
          this.voteResult.yes_persent = Math.round((this.voteResult.yes / (this.voteResult.yes + this.voteResult.no)) * 100);
          this.voteResult.no_persent = 100 - this.voteResult.yes_persent;
        }
      });
  }
  showResult() {
    this.tempResultShow = !this.tempResultShow;
  }

  addSubscription(form) {

    if (form.valid) {
      this.state.operating = true;
      this.state.state = '';
      this.state.message = '';

      this.apiService
        .post(false, "subscription", { email: form.value["email"] })
        .subscribe(response => {
          this.state.operating = false;
          form.form.reset();
          if (response.code == 200 && response.msg === 'SUCCESS') {
            this.state.message = 'تم الاشتراك بنجاح';
            this.state.message_en = 'successfully registered';
            form.form.reset();
          } else if (response.code == 111) {
            this.state.message = 'هذا البريد الالكتروني مشترك مسبقا';
            this.state.message_en = 'this email already registered';
          }
        });
      form.form.reset();
    }
  }
  getExperiments() {
    this.state.loaded = false;
    this.state.operating = true;
    this.apiService.get(false, 'getAllExperiments', {}).subscribe(result => {
      this.experiments = result.data.experiments;
      this.state.loaded = true;
      this.state.operating = false;
      // this.moreAndLess();
      this.addMoreToExperiments(this.experiments, 'exp')

    });
  }
  moreAndLess() {
    let moreText;
    var showChar = 100;
    var ellipsestext = "...";
    if (this.currentLang == 'ar') {
      moreText = 'المزيد';
    } else {
      moreText = "more"
    }
    $(document).ready(function () {
      $('#more p').each(function () {
        var content = $('#more p').html();
        if (content.length > showChar) {
          var c = content.substr(0, showChar);
          var html = c + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span><span class="morecontent">&nbsp;&nbsp;<a style="color:white" href="/pages/fraud" class="morelink">' + moreText + '</a></span>';
          $('#more p').html(html);
        }
      });
    });
  }
  addMoreToExperiments(data, type) {
    this.newExperiments = [];
    let moreText = 'المزيد';
    let moreText_en = "more"
    var showChar;
    if (this.innerWidth < 769) {
      showChar = 60;
    } else {
      showChar = 100;
    }
    var ellipsestext = "...";
    data.forEach(exp => {
      let expNew = exp;
      if (expNew.description.length > showChar) {
        var c = expNew.description.substr(0, showChar);
        expNew.description = c + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span><span class="morecontent">&nbsp;&nbsp;<a style="color:white" href="' + '/pages/ShareYourExperience/experience/' + expNew.id + '" class="morelink">' + moreText + '</a></span>';
      }
      if (expNew.description_en) {
        if (expNew.description_en.length > showChar) {
          var c = expNew.description_en.substr(0, showChar);
          expNew.description_en = c + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span><span class="morecontent">&nbsp;&nbsp;<a style="color:white" href="' + '/pages/ShareYourExperience/story/' + expNew.id + '" class="morelink">' + moreText_en + '</a></span>';
        }
      }
      this.newExperiments.push(expNew)
    })

  }
  addMoreToSubFraud(data) {
    this.newSubFraudCategory = [];
    let moreText = 'المزيد';
    let moreText_en = "more"
    var showChar;
    // if (this.innerWidth < 769) {
    //   showChar = 100;
    // } else {
    showChar = 200;
    // }
    var ellipsestext = "...";
    data.forEach(exp => {
      let expNew = exp;
      // if (expNew.id != 12) {
      if (expNew.oldest_fraud_sub_category) {
        if (expNew.oldest_fraud_sub_category.description.length > showChar) {
          var c = expNew.oldest_fraud_sub_category.description.substr(0, showChar);
          expNew.description = c + '<span class="moreellipses">' + ellipsestext + '&nbsp;</span><span class="morecontent">&nbsp;&nbsp;<a style="color:white" href="' + '/pages/fraud/fraudSubDetails/' + expNew.fraud_id + ',' + expNew.id + '" class="morelink">' + moreText + '</a></span></p>';
          $('a.morelink').css('color', 'white');
        }
        if (expNew.oldest_fraud_sub_category.description_en.length > showChar) {
          var c = expNew.oldest_fraud_sub_category.description_en.substr(0, showChar);
          expNew.description_en = c + '<span class="moreellipses">' + ellipsestext + '&nbsp;<span class="morecontent">&nbsp;&nbsp;<a style="color:white" href="' + '/pages/fraud/fraudSubDetails/' + expNew.fraud_id + ',' + expNew.id + '" class="morelink">' + moreText_en + '</a></span></span></p>';
          $('a.morelink').css('color', 'white');
        }
      }
      this.newSubFraudCategory.push(expNew);
      // }

    })
    $('a.morelink').css('color', 'white');
  }
  agree() {
    localStorage.setItem("agree", "true");
    this.showDisclamerFlag = "true";
  }
  getImage(image: string) {
    return this.urls.getStorageUrl() + '/' + JSON.parse(image)[0].download_link;
  }

}
